import { defineComponent as n, useCssVars as o, openBlock as r, createElementBlock as s, createVNode as _, unref as i } from "vue";
import { SpinnerIcon as p } from "@frontiers/brink-icons";
import { _ as t } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/index39.css';const l = { class: "Spinner" }, c = /* @__PURE__ */ n({
  __name: "Spinner",
  props: {
    color: { default: "currentColor" },
    size: { default: "md" },
    display: { default: "flex" }
  },
  setup(a) {
    return o((e) => ({
      a20df75e: e.display
    })), (e, f) => (r(), s("div", l, [
      _(i(p), {
        class: "Spinner__icon",
        fill: e.color,
        size: e.size
      }, null, 8, ["fill", "size"])
    ]));
  }
});
const S = /* @__PURE__ */ t(c, [["__scopeId", "data-v-5762ff63"]]);
export {
  S as Spinner
};
